import { render, staticRenderFns } from "./promoFinished.vue?vue&type=template&id=5d121f1c&scoped=true&lang=pug"
import script from "./promoFinished.vue?vue&type=script&lang=js"
export * from "./promoFinished.vue?vue&type=script&lang=js"
import style0 from "./promoFinished.vue?vue&type=style&index=0&id=5d121f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d121f1c",
  null
  
)

export default component.exports